import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DateFormatPipe } from '../pipes/dateFormat.pipe';
import { type } from 'os';

const headers = new HttpHeaders({
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
});


@Injectable()
export class CommonfilterService {
  s3_url = '';
  locationUrl = '/superadmin/rest/mgmt/account/locations';
  servicesectorUrl = '/superadmin/rest/mgmt/account/serviceSectors';
  baseLocationUrl = '/superadmin/rest/mgmt/account/baseLocations';
  accountConfigUrl = '/superadmin/rest/mgmt/account/config';
  licensePackagesUrl = '/superadmin/rest/mgmt/account/licensepackages';
  s3Url = '/superadmin/rest/mgmt/login/s3Url';


  constructor(private http: HttpClient, private datepipe: DateFormatPipe) {

  }

  createfilterParams(tblId) {

    let filterParameter = '';
    $('#' + tblId + ' tr td.filterParam').each(function () {
      let start_endVal='';
      const field_operator = $(this).find('select[name=operator] option:selected').val();
      if(field_operator==='startEndWith'){
        
       let specid=$(this).find('select[name=operator]').attr('id');
       specid=specid.split('_')[0];

     $(this).find('input[type="text"]').each (function(){
     if(start_endVal!=""){
       start_endVal=start_endVal+'---';
      }
     start_endVal=start_endVal+$(this).val() ;
    });
      filterParameter = filterParameter + specid + '-' + field_operator + '=' + start_endVal + '&';
      }
     else{

    
      if ($(this).find('[name=fieldname]').is('select')) {
        const id = $(this).find('select[name=fieldname]').attr('id');
        let value = $('#' + tblId + ' #' + id + ' option:selected').val();
        if (value === '' || value === undefined) {
          value = 0;
        }
        if (value !== '0') {
          filterParameter = filterParameter + id + '-' + field_operator + '=' + value + '&';
        }
      } else if ($(this).find('[name=fieldname]').is('input')) {
        const id = $(this).find('input[name=fieldname]').attr('id');
        const value = $(this).find('input[name=fieldname]').val();
        if (value !== '' && value !== undefined) {
          filterParameter = filterParameter + id + '-' + field_operator + '=' + value + '&';
        }
      }
        }    });

    filterParameter = filterParameter.slice(0, -1);
    return filterParameter;
  }
  
  clearFilterParams(tblId) {
    $('#' + tblId + ' tr td.filterParam').each(function () {
      $(this).find('select[name=operator]').val('eq');
      if ($(this).find('[name=fieldname]').is('select')) {
        const id = $(this).find('select[name=fieldname]').attr('id');
        $('#' + tblId + ' #' + id).val(0);


      } else if ($(this).find('[name=fieldname]').is('input')) {

        $(this).find('input[name=fieldname]').val('');

      }
    });
  }

  filterParams_without_operators = function (tblId) {
    let filterParameter = '';
    $('#' + tblId + ' tr td.filterParam').each(function () {
      if ($(this).find('[name=fieldname]').is('select')) {
        const id = $(this).find('select[name=fieldname]').attr('id');
        let value = $('#' + tblId + ' #' + id + ' option:selected').val();
        if (value === '' || value === undefined || value === 'Any') {
          value = 0;
        }
        if (value !== '0') {
          filterParameter = filterParameter + id + '=' + value + '&';
        }
      } else if ($(this).find('[name=fieldname]').is('input')) {
        const id = $(this).find('input[name=fieldname]').attr('id');
        const value = $(this).find('input[name=fieldname]').val();
        if (value !== '') {
          filterParameter = filterParameter + id + '=' + value + '&';
        }

      }
    });

    return filterParameter;

  };
  /** Fetch serviceSectors */
  getLocations(): Observable<any> {
    return this.http.get(this.locationUrl, { headers: headers });

  }
  getS3UrlFromBackend(): Observable<any> {
    return this.http.get(this.s3Url, { headers: headers });
  }
  /** Fetch serviceSectors */
  getServiceSectors(): Observable<any> {
    return this.http.get(this.servicesectorUrl, { headers: headers });

  }
  /** Fetch serviceSectors */
  getBaseLocation(): Observable<any> {
    return this.http.get(this.baseLocationUrl, { headers: headers });

  }
  getConfigData() {
    return this.http.get(this.accountConfigUrl, { headers: headers });
  }

  createFilterForCustomer = function (tableId) {
    const fromdateval = $('#' + tableId + ' #fromdate_customer').val();
    const todateval = $('#' + tableId + ' #todate_customer').val();
    const filterParam = 'from=' + fromdateval + '&to=' + todateval;
    return filterParam;
  };


  setS3Url(data) {
    this.s3_url = data;
  }
  getS3Url() {
    return this.s3_url;
  }
  getScheduleStringFromTimeSpec(timeSpec) {
    let scheduleStr = '';
    switch (timeSpec.recurringType) {
      case 'Once':
        scheduleStr += this.datepipe.dateTransform(timeSpec.startDate) + ' ';

        break;
      case 'Daily':
        if (timeSpec.terminator.endDate != null) {
          scheduleStr += 'From ' + this.datepipe.dateTransform(timeSpec.startDate) + ' to '
            + this.datepipe.dateTransform(timeSpec.terminator.endDate) + ' ';
        } else { }
        scheduleStr += 'everyday ';
        break;
      case 'Weekly':
        let repeatIntervals = JSON.stringify(this.getRepeatIntervalString(timeSpec.repeatIntervals));
        repeatIntervals = this.replaceAll(repeatIntervals, '"', '') + ' ';
        repeatIntervals = this.replaceAll(repeatIntervals, ',', ', ');
        scheduleStr += '' + repeatIntervals;
        break;
      case 'Monthly':
        const repeatInterval = JSON.stringify(this.getRepeatIntervalString(timeSpec.repeatIntervals));
        scheduleStr += 'Weekly on ' + this.replaceAll(repeatInterval, '"', '') + ' ';
        break;
      case 'WeeklyMonthly':
        const repeatIntervalss = JSON.stringify(this.getRepeatIntervalString(timeSpec.repeatIntervals));
        scheduleStr += 'Weekly on ' + this.replaceAll(repeatIntervalss, '"', '') + ' ';
        break;
    }

    let count = 0;
    timeSpec.timeSlots.forEach(function (timeslot) {
      if (count === 0) {
        scheduleStr += timeslot.sTime + '-' + timeslot.eTime;
      } else {
        scheduleStr += ' and ' + timeslot.sTime + '-' + timeslot.eTime;
      }
      count++;
    });
    return scheduleStr;
  }


  getRepeatIntervalString = function (rptIntervals) {
    const days = [];
    rptIntervals.forEach(function (selIndex) {
      if (!isNaN(selIndex)) {
        selIndex = '' + selIndex;
      }
      switch (selIndex) {
        case '1': days.push('Sunday'); break;
        case '2': days.push('Monday'); break;
        case '3': days.push('Tuesday'); break;
        case '4': days.push('Wednesday'); break;
        case '5': days.push('Thursday'); break;
        case '6': days.push('Friday'); break;
        case '7': days.push('Saturday'); break;
      }
    });
    return days.toString();
  };

  replaceAll = function (actualString, search, replacement) {
    // var target = this;
    return actualString.replace(new RegExp(search, 'g'), replacement);
  };
  getLicensePackages(): Observable<any> {
    return this.http.get(this.licensePackagesUrl, { headers: headers });
  }



}
